import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { Fleet } from '@/types/vehicleAllocation'

const GET_FLEETS_KEY = 'fleets'

export const useGetFleets = () => {
    return useAppQuery<Fleet[]>({
        queryKey: [GET_FLEETS_KEY],
        queryFn: () =>
            createInstance({
                url: '/fleets',
                method: 'GET',
            }),
        refetchOnMount: false,
        staleTime: 60 * 1024,
    })
}
